export default {
  identifier: 'generic',
};
